export const presentCaption = async ({
    message,
    autoTranslate,
    translateCaption,
    onTranslationUnavailable,
    onTranslationSuccess,
    addMessage,
}) => {
    const translatedCaption = autoTranslate
        ? await translateCaption(
              message.content,
              onTranslationUnavailable
          )
        : null;
    const content = translatedCaption?.text || message.content;

    if (
        autoTranslate &&
        translatedCaption?.text &&
        translatedCaption.text !== message.content
    ) {
        onTranslationSuccess?.(message.analyticsSessionId);
    }

    const displayedMessage = {
        ...message,
        content,
        sourceLanguage:
            translatedCaption?.sourceLanguage ||
            message.sourceLanguage ||
            null,
        // Source captions remain selectable for word/phrase lookup. English
        // auto-translations are display-only.
        isCaption: !autoTranslate,
    };

    addMessage(displayedMessage);
    return displayedMessage;
};
